/**
 * usePraticaDetail — F-005 Phase 4 (IMPL-P4-005).
 *
 * Polling hook per il dettaglio + timeline di una singola pratica. Refetch
 * ogni 15s (più aggressivo della lista perché la pagina di dettaglio è
 * tipicamente quella in cui il cliente attende un cambiamento di stato),
 * fermato quando lo stato è terminale.
 *
 * `enabled: !!id` evita la query con id vuoto durante mount iniziale di
 * `useParams` (timing react-router).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchPraticaDetail } from '../lib/cliente-pratiche-client';
import { isTerminalStato } from '../lib/stato-meta';

const DETAIL_REFETCH_INTERVAL_MS = 15_000;

export function usePraticaDetail(id: string) {
  return useQuery({
    queryKey: ['pratiche-cliente', 'detail', id],
    queryFn: () => fetchPraticaDetail(id),
    enabled: !!id,
    refetchInterval: (query) => {
      const stato = query.state.data?.pratica.stato;
      if (!stato) return DETAIL_REFETCH_INTERVAL_MS;
      return isTerminalStato(stato) ? false : DETAIL_REFETCH_INTERVAL_MS;
    },
  });
}
